// import { useEffect, useState } from "react";
// import { db } from "../../firebase"; // Firebase конфігурація
// import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import css from "./adm.module.css";

// export default function AdminAboutAuth() {
//   const [content, setContent] = useState({});
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchData = async () => {
//       const docRef = doc(db, "aboutAuthContent", "mainPageTexts");
//       const docSnap = await getDoc(docRef);

//       if (docSnap.exists()) {
//         setContent(docSnap.data()); // Якщо документ існує
//       } else {
//         alert("Документ не існує! Буде створено новий документ.");
//         setContent({
//           section1_intro: "",
//           section1_general: "",
//           section1_desc: "",
//           section1_offer: "",
//           section2_intronew: "",
//           section2_intro: "",
//           section2_post: "",
//           section2_general: "",
//           section2_desc: "",
//         });
//       }
//       setLoading(false);
//     };

//     fetchData();
//   }, []);

//   const handleChange = (field, value) => {
//     setContent((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const handleSave = async () => {
//     const docRef = doc(db, "aboutAuthContent", "mainPageTexts");
//     try {
//       // Якщо документ існує, оновити; якщо ні, створити новий
//       const docSnap = await getDoc(docRef);
//       if (docSnap.exists()) {
//         await updateDoc(docRef, content);
//       } else {
//         await setDoc(docRef, content);
//       }
//       alert("Збережено успішно!");
//     } catch (error) {
//       console.error("Помилка при збереженні документа: ", error);
//       alert("Помилка збереження. Перевірте консоль для деталей.");
//     }
//   };

//   if (loading) return <div>Завантаження...</div>;

//   return (
//     <div>
//       <h1>Редагування текстів AboutAuth</h1>
//       <form>
//         {/* Поля для авторів */}
//         <div style={{ marginBottom: "20px" }}>
//           <h3>Вступ для авторів</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section1_intro || ""}
//             onChange={(value) => handleChange("section1_intro", value)}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <h3>Загальне звернення до автора</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section1_general || ""}
//             onChange={(value) => handleChange("section1_general", value)}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <h3>Опис для авторів</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section1_desc || ""}
//             onChange={(value) => handleChange("section1_desc", value)}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <h3>Оферта</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section1_offer || ""}
//             onChange={(value) => handleChange("section1_offer", value)}
//           />
//         </div>

//         {/* Нове поле */}
//         <div style={{ marginBottom: "20px" }}>
//           <h3>Повага</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section2_intronew || ""}
//             onChange={(value) => handleChange("section2_intronew", value)}
//           />
//         </div>

//         {/* Поля для художників */}
//         <div style={{ marginBottom: "20px" }}>
//           <h3>Вступ для художників</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section2_intro || ""}
//             onChange={(value) => handleChange("section2_intro", value)}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <h3>Email для художників</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section2_post || ""}
//             onChange={(value) => handleChange("section2_post", value)}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <h3>Загальне звернення до художників</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section2_general || ""}
//             onChange={(value) => handleChange("section2_general", value)}
//           />
//         </div>

//         <div style={{ marginBottom: "20px" }}>
//           <h3>Опис для художників</h3>
//           <ReactQuill
//             className={css.quilForAutorAnd}
//             theme="snow"
//             value={content.section2_desc || ""}
//             onChange={(value) => handleChange("section2_desc", value)}
//           />
//         </div>

//         {/* Кнопка збереження */}
//         <button type="button" onClick={handleSave}>
//           Зберегти зміни
//         </button>
//       </form>
//     </div>
//   );
// }
// src/components/admin/AdminAboutAuth.jsx
// AdminAboutAuth.jsx (pure React)
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import css from "./adm.module.css";

/* === Quill toolbar / formats (поза компонентом) === */
const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ align: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["blockquote", "code-block"],
    ["link", "image", "clean"],
  ],
  clipboard: { matchVisual: false },
  history: { delay: 500, maxStack: 100, userOnly: true },
};

const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "align",
  "list",
  "indent",
  "blockquote",
  "code-block",
  "link",
  "image",
];

/* === Простий підкомпонент без хуків === */
function Editor({ value, onChange, placeholder, className }) {
  return (
    <ReactQuill
      className={className}
      theme="snow"
      value={value || ""}
      onChange={onChange}
      modules={quillModules}
      formats={quillFormats}
      placeholder={placeholder}
    />
  );
}

const DEFAULT_CONTENT = {
  section1_intro: "",
  section1_general: "",
  section1_desc: "",
  section1_offer: "",
  section2_intronew: "",
  section2_intro: "",
  section2_post: "",
  section2_general: "",
  section2_desc: "",
};

export default function AdminAboutAuth() {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const docRef = doc(db, "aboutAuthContent", "mainPageTexts");
        const snap = await getDoc(docRef);
        if (!isMounted) return;
        if (snap.exists()) {
          setContent({ ...DEFAULT_CONTENT, ...snap.data() });
        } else {
          // документ буде створено при збереженні
          setContent(DEFAULT_CONTENT);
        }
      } catch (e) {
        console.error(e);
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);

  const handleChange = (field, value) =>
    setContent((prev) => ({ ...prev, [field]: value }));

  const handleSave = async () => {
    try {
      const docRef = doc(db, "aboutAuthContent", "mainPageTexts");
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        await updateDoc(docRef, content);
      } else {
        await setDoc(docRef, content);
      }
      alert("Збережено успішно!");
    } catch (e) {
      console.error("Помилка при збереженні:", e);
      alert("Помилка збереження. Деталі у консолі.");
    }
  };

  if (loading) return <div>Завантаження...</div>;

  return (
    <div className={css.wrap}>
      <h1>Редагування текстів AboutAuth</h1>
      <form className={css.form}>
        <div className={css.block}>
          <h3>Вступ для авторів</h3>
          <Editor
            className={css.quilForAutorAnd}
            value={content.section1_intro}
            onChange={(v) => handleChange("section1_intro", v)}
            placeholder="Напишіть вступний текст..."
          />
        </div>

        <div className={css.block}>
          <h3>Загальне звернення до автора</h3>
          <Editor
            className={css.quilForAutorAnd}
            value={content.section1_general}
            onChange={(v) => handleChange("section1_general", v)}
            placeholder="Напишіть звернення..."
          />
        </div>

        <div className={css.block}>
          <h3>Опис для авторів</h3>
          <Editor
            className={css.quilForAutorAnd}
            value={content.section1_desc}
            onChange={(v) => handleChange("section1_desc", v)}
            placeholder="Опишіть деталі/умови..."
          />
        </div>

        <div className={css.block}>
          <h3>Оферта</h3>
          <Editor
            className={css.quilForAutorAnd}
            value={content.section1_offer}
            onChange={(v) => handleChange("section1_offer", v)}
            placeholder="Текст оферти..."
          />
        </div>

        <div className={css.block}>
          <h3>Повага</h3>
          <Editor
            className={css.quilForAutorAnd}
            value={content.section2_intronew}
            onChange={(v) => handleChange("section2_intronew", v)}
            placeholder="Коротке звернення про повагу..."
          />
        </div>

        <div className={css.block}>
          <h3>Вступ для художників</h3>
          <Editor
            className={css.quilForAutorAnd}
            value={content.section2_intro}
            onChange={(v) => handleChange("section2_intro", v)}
            placeholder="Напишіть вступний текст..."
          />
        </div>

        <div className={css.block}>
          <h3>Email для художників</h3>
          <Editor
            className={css.quilForAutorAnd}
            value={content.section2_post}
            onChange={(v) => handleChange("section2_post", v)}
            placeholder="Вкажіть email або інструкції для звʼязку..."
          />
        </div>

        <div className={css.block}>
          <h3>Загальне звернення до художників</h3>
          <Editor
            className={css.quilForAutorAnd}
            value={content.section2_general}
            onChange={(v) => handleChange("section2_general", v)}
            placeholder="Напишіть звернення..."
          />
        </div>

        <div className={css.block}>
          <h3>Опис для художників</h3>
          <Editor
            className={css.quilForAutorAnd}
            value={content.section2_desc}
            onChange={(v) => handleChange("section2_desc", v)}
            placeholder="Опишіть деталі/умови..."
          />
        </div>

        <button type="button" className={css.saveBtn} onClick={handleSave}>
          Зберегти зміни
        </button>
      </form>
    </div>
  );
}
